import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import StyledTable from "components/StyledTable";
import { useSortedData } from "../../../lib/hooks/useSortedData";
import { Product } from "models/Product";

type Props = {
  serials: Product[];
  onSelect?: (serial: Product) => void;
};

const AvailableSerialsTable: React.FC<Props> = ({ serials, onSelect }) => {
  const {
    data: sortedSerials,
    sortBy,
    sortDir,
    setSortBy,
  } = useSortedData(serials, [
    { key: "item" },
    { key: "description" },
    { key: "serial", defaultSortDir: "desc" },
  ]);

  return (
    <TableContainer>
      <StyledTable size="small" striped noBottomBorder>
        <TableHead>
          <TableRow>
            <TableCell>
              <TableSortLabel
                active={sortBy === "item"}
                direction={sortDir}
                onClick={() => setSortBy("item")}
              >
                Artikelkod
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={sortBy === "description"}
                direction={sortDir}
                onClick={() => setSortBy("description")}
              >
                Benämning
              </TableSortLabel>
            </TableCell>
            <TableCell align="right">
              <TableSortLabel
                active={sortBy === "serial"}
                direction={sortDir}
                onClick={() => setSortBy("serial")}
              >
                Serienummer
              </TableSortLabel>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {sortedSerials.length === 0 && (
            <TableRow>
              <TableCell colSpan={5} align="center" sx={{ fontStyle: "italic" }}>
                Inga data att visa
              </TableCell>
            </TableRow>
          )}

          {sortedSerials.map((row) => {
            const isChild = !!row.parentId;

            return (
              <TableRow key={row.id} hover onClick={() => onSelect?.(row)}>
                {!isChild && (
                  <>
                    <TableCell sx={{ textWrap: "nowrap" }}>{row.item}</TableCell>
                    <TableCell sx={{ width: "100%" }}>{row.description}</TableCell>
                  </>
                )}
                <TableCell sx={{ textWrap: "nowrap" }} align="right">
                  {row.serial}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </StyledTable>
    </TableContainer>
  );
};

export default AvailableSerialsTable;
